import { render, staticRenderFns } from "./AccountHolderAuthorizedSigners.vue?vue&type=template&id=aec6cc62&scoped=true"
import script from "./AccountHolderAuthorizedSigners.vue?vue&type=script&lang=ts"
export * from "./AccountHolderAuthorizedSigners.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderAuthorizedSigners.vue?vue&type=style&index=0&id=aec6cc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec6cc62",
  null
  
)

export default component.exports